import { NotificationSubscriptionClientData } from "@/model/data/notifications/NotificationSubscriptionClientData";

export class SetNotificationSubscriptionReqData {
    subscriptions: NotificationSubscriptionClientData[] = [];

    constructor(subscriptions: NotificationSubscriptionClientData[]) {
        this.subscriptions = subscriptions;
    }
}
